module.exports = __webpack_public_path__ + "img/what_does_bricklayer_do_button.3d251877.jpg";